// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  version: '3.14.1',
  buildDate: '1/27/2026, 5:10:44 PM',
  environment: 'dev',
  mocksEnabled: false,
  invoice: {
    defaultMonthsTimespan: 12,
    maxMonthsTimespan: 120,
  }
};
